module.exports = __webpack_public_path__ + "img/icon_03.37ff9d9d.gif";